interface OctaLogoProps {
  className?: string;
  animate?: boolean;
}

export function OctaLogo({ className = "w-5 h-5", animate = false }: OctaLogoProps) {
  return (
    <svg
      className={`${className}${animate ? " animate-pulse" : ""}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="logo-icon"
    >
      <circle cx="12" cy="12" r="9" stroke="#F26522" strokeWidth="4" fill="none" />
    </svg>
  );
}
